import { Stack } from "@mui/material";
import { PrimaryLinearProgress } from "react-common-ui-library";
import { FormProvider, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ACCOUNT_SETUP_COMPLETION_FRACTION,
  ACCOUNT_SETUP_HEADING,
  ACCOUNT_SETUP_PAGE_PROGRESS_VALUE,
  CONFIRM_PASSWORD_FIELD_NAME,
  PASSWORD_FIELD_NAME,
  USER_NAME_FIELD_NAME,
} from "../../../Constants/AccountSetupConstants";
import {
  ACCOUNT_CREATION_FLOW,
  ACCOUNT_CREATION_ROUTE,
  BACK_BUTTON_TEXT,
  CONSUMER_ACCOUNT_CREATION,
  H1,
  H3,
  MODE_ALL,
  NAME_AND_CONTACT_ROUTE,
  PROGRESS_LABEL,
  REVIEW_APPLICATION_ROUTE,
  SPACING_3_5,
  SPACING_4_5,
} from "../../../Constants/CommonConstants";
import { saveAccountSetupInformation } from "../../../Features/AccountCreationSlice";
import { manageAccountCreationSelector } from "../../../Selectors/AccountCreationSelector";
import { StyledTypographyHeader } from "../../../Styles/Common/CommonStyles";
import AccountSetupFields from "./AccountSetupFields";

/**
 * @description contains user name, password and confirm password fields that are used to verify username and password and confirm password .
 * @returns {ReactNode} Render the user name, password and confirm password and navigate to review page after valid inputs.
 */
const AccountSetup = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const intl = useIntl();

  const { userName, password } = useSelector((state) =>
    manageAccountCreationSelector(state)
  );

  const methods = useForm({
    mode: MODE_ALL,
    criteriaMode: MODE_ALL,
    defaultValues: {
      [USER_NAME_FIELD_NAME]: userName,
      [PASSWORD_FIELD_NAME]: password,
      [CONFIRM_PASSWORD_FIELD_NAME]: password,
    },
  });

  const navigateToNameAndContactPage = () => {
    navigate(`/${ACCOUNT_CREATION_ROUTE}/${NAME_AND_CONTACT_ROUTE}`);
  };

  const handleNextStep = (data) => {
    dispatch(saveAccountSetupInformation(data));
    navigate(`/${ACCOUNT_CREATION_ROUTE}/${REVIEW_APPLICATION_ROUTE}`);
    sessionStorage.setItem(ACCOUNT_CREATION_FLOW, CONSUMER_ACCOUNT_CREATION);
    return new Promise((resolve) => {
      setTimeout(() => resolve(), 1000);
    });
  };

  return (
    <Stack gap={SPACING_3_5}>
      <Stack gap={SPACING_4_5}>
        <PrimaryLinearProgress
          progressValue={ACCOUNT_SETUP_PAGE_PROGRESS_VALUE}
          progressLabel={PROGRESS_LABEL}
          currentPage={ACCOUNT_SETUP_COMPLETION_FRACTION}
          backButtonText={BACK_BUTTON_TEXT}
          backButtonOnClickHandler={navigateToNameAndContactPage}
        />
        <StyledTypographyHeader
          id={ACCOUNT_SETUP_HEADING}
          component={H1}
          variant={H3}
        >
          {intl.formatMessage({
            id: ACCOUNT_SETUP_HEADING,
          })}
        </StyledTypographyHeader>
      </Stack>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleNextStep)}>
          <AccountSetupFields handleNextStep={handleNextStep} />
        </form>
      </FormProvider>
    </Stack>
  );
};
export default AccountSetup;
